import './HeaderLoggedIn.styles.scss';
import React, { useContext } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Avatar, Badge, Button } from '@material-ui/core';
import { SmsRounded } from '@material-ui/icons';

import userImg from '../../assets/imgs/user.png';
import UesrContext from '../../contexts/user-context/UserProvider';
import MainSearch from './MainSearch';
import LiveChatContext from '../../contexts/live-chat-context/LiveChatProvider';

const HeaderLoggedIn = () => {
	const { loggedIn, user, removeCurrentUser } = useContext(UesrContext);
	const { unreadChatCount, toggleLiveChat } = useContext(LiveChatContext);
	const sleep = ms => new Promise(r => setTimeout(r, ms));

	const handleLogOut = async () => {
		await sleep(100);
		removeCurrentUser();
	};

	const renderChatCount = count => {
		if (count > 0) {
			if (count < 10) {
				return count;
			} else {
				return '9+';
			}
		} else {
			return 0;
		}
	};

	return (
		<div className="headerLoggedIn">
			<MainSearch />

			<Badge
				className="chatBtn"
				badgeContent={renderChatCount(unreadChatCount)}
				color="error"
				onClick={toggleLiveChat}
			>
				<SmsRounded color="action" />
			</Badge>
			<Avatar
				src={loggedIn ? user.avatar && user.avatar : userImg}
				alt="user img"
				component={RouterLink}
				to={`/profile/${user.username}`}
			/>
			<div className="actionBtns">
				<Button
					color="primary"
					variant="contained"
					disableElevation
					component={RouterLink}
					to="/createPost"
				>
					Create Post
				</Button>
				<Button
					color="default"
					variant="contained"
					disableElevation
					onClick={handleLogOut}
				>
					Signout
				</Button>
			</div>
		</div>
	);
};

export default HeaderLoggedIn;
